import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

export interface TerminalQueryParams {
  key_word?: string
  group_id?: number
  asc?: boolean
  sort: string
  page: number
  limit: number
}

export interface TerminalInfo {
  device_id: string // 终端id
  computer_name: string // 计算机名
  user_mark: string // 登记用户名
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  count: number // 拦截次数
  /** 终端状态，1：在线，2：离线 */
  login_status: string
  /** 系统类型 1-windows 2-linux */
  system_type?: number
}

export interface DetailQueryParams {
  device_id: string // 终端id
  key_word?: string
  page: number
  limit: number
  /** 策略id */
  strategy_id?: string
}

export interface DetailInfo {
  domain: string // 域名
  category_name: string // 分类名
  intercept_time: string // 拦截时间
  /** 触发策略 */
  strategy_name?: string
}

@Injectable()
export class TerminalViewService {
  constructor (private http: Http) {

  }

  @ParamsClean()
  @InvokeThrottle()
  getTerminalList (params: TerminalQueryParams) {
    return this.http.post<{
      total: number
      list: TerminalInfo[]
    }>('/terminal/net-limit/stat', params)
  }

  @ParamsClean()
  @InvokeThrottle()
  getDetailList (params: DetailQueryParams) {
    return this.http.post<{
      total: number
      list: DetailInfo[]
    }>('/terminal/net-limit/list', params)
  }

  download (type: 0|1, options: DetailQueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/terminal/net-limit/list/export', params, moduleName)
  }
}
